export default {
	APP_CONNECTED: 'APP/CONNECTED',
	APP_LIMIT_REACHED: 'APP/LIMIT_REACHED',
	APP_INIT: 'APP/INIT',
	APP_CONFIG_LOADED: 'APP/CONFIG_LOADED',
	APP_PING_SERVER: 'APP/PING_SERVER',
	APP_SKIN_LOADED: 'APP/SKIN_LOADED',
	APP_ERROR_CAUGHT: 'APP/ERROR_CAUGHT',
	CHARACTERS_SELECT: 'CHARACTERS/SELECT',
	GAME_ADD_SIMULATED_PLAYER: 'GAME/ADD_SIMULATED_PLAYER',
	GAME_END: 'GAME/END',
	GAME_RESET: 'GAME/RESET',
	GAME_SETTINGS: 'GAME/SETTINGS',
	GAME_START: 'GAME/START',
	GAME_UPDATE: 'GAME/UPDATE',
	GAME_STUDENT_SUBMISSION_UPDATE: 'GAME/STUDENT_SUBMISSION_UPDATE',
	GAME_MOVE_TO_NEXT_ACTIVITY: 'GAME/MOVE_TO_NEXT_ACTIVITY',
	FEATURE_FLAGS_GET: 'FEATURE_FLAGS/GET',
	FEATURE_FLAGS_GET_SUCCESS: 'FEATURE_FLAGS/GET_SUCCESS',
	PREVIEW_DATA_SUCCESS: 'PREVIEW/_DATA_SUCCESS',
	PREVIEW_INITIALIZE: 'PREVIEW/INITIALIZE',
	QUESTION_ANSWER_SELECT: 'QUESTION/ANSWER_SELECT',
	QUESTION_TRANSITION_ENDED: 'QUESTION/TRANSITION_ENDED',
	SESSION_SETTINGS_HIDE_STUDENT_NAMES_UPDATE: 'SESSION/SETTINGS/HIDE_STUDENT_NAMES_UPDATE',
	SPLASH_COMPLETE: 'SPLASH/COMPLETE',
	SPLASH_INIT: 'SPLASH/INIT',
	USER_CONNECT_SUCCESS: 'USER/CONNECT_SUCCESS',
	USER_INTERACTION_UPDATE: 'USER/INTERACTION_UPDATE',
	APP_WINDOW_RESIZE: 'APP/WINDOW_RESIZE',
	GET_CURRENT_NUMBER_OF_CORRECT_ANSWERS_BY_PARTICIPANTS:
		'QUESTION/GET_CURRENT_NUMBER_OF_CORRECT_ANSWERS_BY_PARTICIPANTS',
	SET_CURRENT_NUMBER_OF_CORRECT_ANSWERS_BY_PARTICIPANTS:
		'QUESTION/SET_CURRENT_NUMBER_OF_CORRECT_ANSWERS_BY_PARTICIPANTS',
	AUDIO_UPDATE: 'AUDIO/UPDATE',
	ACCESSIBILITY_DATA_FETCHED: 'ACCESSIBILITY/DATA_FETCHED',
	ANIMATIONS_TOGGLE_UPDATE: 'ANIMATIONS/TOGGLE_UPDATE',
}
